'use es6';

import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';
import { connect } from 'react-redux';
import Raven from 'Raven';
import I18n from 'I18n';
import UISelect from 'UIComponents/input/UISelect';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import getTimezoneGroups from 'timezone-utils/utils/getTimezoneGroups';
import getTimezoneOptions from 'MeetingsLib/utils/getTimezoneOptions';
import { INVALID_TZ_GUESS } from 'MeetingsLib/constants/timezone';
var etcTimezones = ['Etc/GMT', 'Etc/GMT+1', 'Etc/GMT+2', 'Etc/GMT+3', 'Etc/GMT+4', 'Etc/GMT+5', 'Etc/GMT+6', 'Etc/GMT+7', 'Etc/GMT+8', 'Etc/GMT+9', 'Etc/GMT+10', 'Etc/GMT+11', 'Etc/GMT+12', 'Etc/GMT-1', 'Etc/GMT-2', 'Etc/GMT-3', 'Etc/GMT-4', 'Etc/GMT-5', 'Etc/GMT-6', 'Etc/GMT-7', 'Etc/GMT-8', 'Etc/GMT-9', 'Etc/GMT-10', 'Etc/GMT-11', 'Etc/GMT-12', 'Etc/GMT-13', 'Etc/GMT-14', 'Etc/UTC'];
var etcTimezoneOptions = {
  text: 'Etc',
  value: 'Etc',
  options: etcTimezones.map(function (tz) {
    return {
      text: tz,
      value: tz
    };
  })
};
var etcTimezoneOptionsMap = etcTimezoneOptions.options.reduce(function (acc, option) {
  acc[option.value] = option.text;
  return acc;
}, {});

var getAllTimezoneOptions = function getAllTimezoneOptions() {
  var _getTimezoneOptions = getTimezoneOptions(),
      options = _getTimezoneOptions.options,
      optionsMap = _getTimezoneOptions.optionsMap;

  return {
    options: [].concat(_toConsumableArray(options), [etcTimezoneOptions]),
    optionsMap: Object.assign({}, optionsMap, {}, etcTimezoneOptionsMap)
  };
};

var etcRegex = new RegExp(/^Etc\//);
var TimezoneSelect = createReactClass({
  displayName: "TimezoneSelect",
  propTypes: {
    userTimezone: PropTypes.string.isRequired,
    setTimezone: PropTypes.func.isRequired,
    activeLocale: PropTypes.string
  },
  getInitialState: function getInitialState() {
    return {
      timezoneOptions: null,
      timezoneOptionsMap: null,
      parsedUserTimezone: null
    };
  },
  componentDidMount: function componentDidMount() {
    var _this = this;

    var userTimezone = this.props.userTimezone;
    setTimeout(function () {
      var _getTimezoneOptions2 = getTimezoneOptions(),
          timezoneOptions = _getTimezoneOptions2.options,
          timezoneOptionsMap = _getTimezoneOptions2.optionsMap;

      var parsedUserTimezone = INVALID_TZ_GUESS;

      try {
        if (etcRegex.test(userTimezone)) {
          parsedUserTimezone = userTimezone;
          var allTimezoneOptions = getAllTimezoneOptions();
          timezoneOptions = allTimezoneOptions.options;
          timezoneOptionsMap = allTimezoneOptions.optionsMap;
          Raven.captureMessage("`Etc/` timezone detected, using custom list of `Etc/` timezones", {
            level: 'info',
            extra: {
              userTimezone: userTimezone
            }
          });
        } else {
          parsedUserTimezone = getTimezoneGroups().resolve(userTimezone);
        }
      } catch (error) {
        Raven.captureMessage("Invalid timezone was given by `moment.tz.guess()`", {
          extra: {
            userTimezone: userTimezone,
            error: error
          }
        });
      }

      _this.setState({
        timezoneOptions: timezoneOptions,
        timezoneOptionsMap: timezoneOptionsMap,
        parsedUserTimezone: parsedUserTimezone
      });
    }, 0);
  },
  UNSAFE_componentWillReceiveProps: function UNSAFE_componentWillReceiveProps(nextProps) {
    var _this$props = this.props,
        currentActiveLocale = _this$props.activeLocale,
        currentUserTimezone = _this$props.userTimezone;
    var nextActiveLocale = nextProps.activeLocale,
        nextUserTimezone = nextProps.userTimezone;

    if (currentActiveLocale !== nextActiveLocale) {
      var _getAllTimezoneOption = getAllTimezoneOptions(),
          timezoneOptions = _getAllTimezoneOption.timezoneOptions,
          timezoneOptionsMap = _getAllTimezoneOption.timezoneOptionsMap;

      this.setState({
        timezoneOptions: timezoneOptions,
        timezoneOptionsMap: timezoneOptionsMap
      });
    }

    if (currentUserTimezone !== nextUserTimezone) {
      this.setState({
        parsedUserTimezone: etcRegex.test(nextUserTimezone) ? nextUserTimezone : getTimezoneGroups().resolve(nextUserTimezone)
      });
    }
  },
  onTimezoneChange: function onTimezoneChange(_ref) {
    var value = _ref.target.value;
    var setTimezone = this.props.setTimezone;
    setTimezone(value);
  },
  renderDropdownText: function renderDropdownText() {
    var _this$state = this.state,
        timezoneOptionsMap = _this$state.timezoneOptionsMap,
        parsedUserTimezone = _this$state.parsedUserTimezone;
    return timezoneOptionsMap[parsedUserTimezone].value || parsedUserTimezone;
  },
  renderAriaLabel: function renderAriaLabel(timezoneOptionsMap, parsedUserTimezone) {
    var userTimezone = timezoneOptionsMap[parsedUserTimezone];

    if (userTimezone) {
      return I18n.text('prebook.timePicker.timezoneLabel', {
        userTimezone: userTimezone
      });
    }

    return I18n.text('prebook.timePicker.timezoneLabelNoneDisplayed');
  },
  render: function render() {
    var _this$state2 = this.state,
        timezoneOptions = _this$state2.timezoneOptions,
        timezoneOptionsMap = _this$state2.timezoneOptionsMap,
        parsedUserTimezone = _this$state2.parsedUserTimezone;

    if (timezoneOptions === null) {
      return /*#__PURE__*/_jsx(UILoadingSpinner, {
        layout: "centered"
      });
    }

    return /*#__PURE__*/_jsx("div", {
      id: "timezone-select-label",
      "aria-label": this.renderAriaLabel(timezoneOptionsMap, parsedUserTimezone),
      children: /*#__PURE__*/_jsx(UISelect, {
        "aria-labelledby": 'timezone-select-label',
        "data-selenium-test": "timezone-select",
        searchClassName: "timezone-select-search",
        className: "p-left-0 p-top-1",
        menuWidth: 275,
        buttonUse: "transparent",
        defaultValue: this.renderDropdownText(),
        placement: "bottom",
        onChange: this.onTimezoneChange,
        options: this.state.timezoneOptions
      })
    });
  }
});
export default connect(function (state) {
  return {
    activeLocale: state.activeLocale
  };
})(TimezoneSelect);